const cascadeBooleanProperty = ([top = false, right = top, bottom = top, left = right] = []) => [top, right, bottom, left];
const PROPERTIES = ['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomRightRadius', 'borderBottomLeftRadius'];
export const toBooleanArray = value => cascadeBooleanProperty((value || '').split(' ').map(part => part === 'true'));
export function style(value) {
  const styleObj = {};
  toBooleanArray(value).forEach((flag, index) => {
    if (flag) {
      styleObj[PROPERTIES[index]] = 0;
    }
  });
  return styleObj;
}